export const lightTheme = {
  buttons: {
    fill: {
      background: {
        primary: "#141d1b",
        primaryHover: "#475263",
        secondary: "#F0F1F3",
        secondaryHover: "#CFD4DB",
        success: "#10B981",
        successHover: "#0B835C",
        danger: "#EF4444",
        dangerHover: "#D93E3E",
        warning: "#F1A965",
        warningHover: "#EF9947",
        neutral: "#FEFEFE",
        neutralHover: "#F9F9F9",
        black: "#000",
        blackHover: "#141d1b",
      },
      text: { light: "#FFFFFF", dark: "#141d1b" },
    },
    outline: {
      background: {
        primary: "#FFFFFF",
        primaryHover: "#CFD4DB",
        secondaryHover: "#F0F1F3",
        successHover: "#B5E9D8",
        dangerHover: "#FAC5C5",
        warningHover: "#FFCEA0",
        neutralHover: "#F0F1F3",
        blackHover: "#F0F1F3",
      },
      text: {
        primary: "#141d1b",
        secondary: "#475263",
        success: "#0B835C",
        danger: "#AA3030",
        warning: "#EF9947",
        neutral: "#141d1b",
        black: "#000000",
      },
      border: {
        primary: "#141d1b",
        primaryHover: "#141d1b",
        secondary: "#CFD4DB",
        secondaryHover: "#475263",
        success: "#10B981",
        successHover: "#0B835C",
        danger: "#EF4444",
        dangerHover: "#AA3030",
        warning: "#F1A965",
        warningHover: "#EF9947",
        neutral: "#CFD4DB",
        neutralHover: "#475263",
        black: "#000000",
        blackHover: "#F0F1F3",
      },
    },
  },
  inputs: {
    background: {
      default: "#FFFFFF",
      disabled: "#F0F1F3",
    },
    border: {
      default: "#94A3B8",
      active: "#97A2B1",
      danger: "#F48282",
      alert: "#F3B77E",
      light: "#F0F1F3",
    },
    text: {
      placeholder: "#878787",
      input: "#0F172A",
      label: "#0F172A",
      infoDefault: "#64748B",
      infoDanger: "#F48282",
      infoAlert: "#F3B77E",
    },
    info: {
      default: "#0F172A",
    },
  },
  toggle: {
    text: "#141d1b",
    switchOn: "#141d1b",
    switchOff: "#CFD4DB",
    knob: "#FEFEFE",
  },
  select: {
    background: "#FEFEFE",
    activeBackground: "#F0F1F3",
    disabledBackground: "#F8F8F8",
    placeholder: "#878787",
    label: "#141d1b",
    disabledLabel: "#AFAFAF",
    defaultCircle: "#CFD4DB",
    singleSelectedCircle: "#141d1b",
    multiSelectedCircle: "#10B981",
  },
  typography: {
    primary: "#141d1b",
    secondary: "#AFAFAF",
    tetriary: "#878787",
    success: "#0B835C",
    danger: "#AA3030",
    warning: "#EF9947",
  },
  switch: {
    background: "#F0F1F3",
    activeBackground: "#FFFFFF",
    text: "#141d1b",
    secondaryText: "#AFAFAF",
  },
  subscriptionBlock: {
    background: "#FFFFFF",
    disabledBackground: "#f7f7f7",
    labelBackground: "#141d1b",
    labelText: "#FFFFFF",
  },
  checkbox: {
    activeBackground: "#141d1b",
    unactiveBackground: "#CFD4DB",
    check: "#FFFFFF",
  },
  assetBlock: {
    background: "#FFFFFF",
    disabledBackground: "#F8F8F8",
    border: "#CFD4DB",
  },
  dashboard: {
    background: "#F9F9F9",
  },
  sidebar: {
    background: "#FEFEFE",
  },
  plate: {
    background: "#FEFEFE",
    greenText: "#0B835C",
    redText: "#AA3030",
    redBackground: "#FAC5C5",
    greenBackground: "#B5E9D8",
    timeBlockBackground: "#F0F1F3",
  },
  settings: {
    grey: "#F0F1F3",
  },
  news: {
    grey: "#F0F1F3",
    red: "#F48282",
    orange: "#F1A965",
    yellow: "#FBE85B",
    white: "#E0E0E0",
  },
  labels: {
    blue: "#B0D6FA",
    blueText: "#004484",
    purple: "#E5D6EE",
    purpleText: "#5B446B",
    green: "#D1F5D1",
    greenText: "#077419",
    orange: "#F7CDA7",
    orangeText: "#643E1A",
  },
  modal: {
    background: "#FFFFFF",
    divider: "#F0F1F3",
  },
};
